<template>
  <div class="mui-toggle">
    <input
      type="checkbox"
      class="tgl tgl-light"
      :id="id"
      :checked="value"
      v-on:input="$emit('input', $event.target.checked)" />
    <label :for="id" class="tgl-btn" />
  </div>
</template>

<script>
export default {
  props: [
    'value'
  ],
  data () {
    return {
      id: null
    }
  },
  mounted () {
    this.id = this._uid
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
.tgl
  display: none
  // add default box-sizing for this scope
  &,
  &:after,
  &:before,
  & *,
  & *:after,
  & *:before,
  & + .tgl-btn
    box-sizing: border-box
    &::selection
      background: none

  + .tgl-btn
    outline: 0
    display: block
    width: 2.05em
    height: 1.2em
    position: relative
    cursor: pointer
    user-select: none
    &:after,
    &:before
      position: relative
      display: block
      content: ""
      width: 50%
      height: 100%

    &:after
      left: 0

    &:before
      display: none

  &:checked + .tgl-btn:after
    left: 50%

// themes
.tgl-light
  + .tgl-btn
    border: 1px solid #dfdfdf
    background: #f0f0f0
    border-radius: 2em
    padding: 2px
    transition: all 0.4s ease
    &:after
      border-radius: 50%
      background: #fefefe
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25)
      transition: all 0.2s ease

  &:checked + .tgl-btn
    background: #37abda
    border: 1px solid #00a3d7
</style>



// WEBPACK FOOTER //
// src/components/MUIToggle.vue